/*
 * Merqelo support chat box. Config comes from snippets/mq-support-chat.liquid (window.MerqeloChat).
 * Talks to the admin hub's public chat API (admin.merqelo.com/api/site): check-ins with the page and
 * cart, messages, and an Ably token for live replies and typing signals. Plain script, no build step.
 * Customer-facing words are in TEXT below; they follow docs/brand/customer-copy.md (no em dashes,
 * reviewed by a second agent).
 */
(function () {
  'use strict';
  var CONFIG = window.MerqeloChat;
  if (!CONFIG || !CONFIG.api || window.__merqeloChat) return;
  window.__merqeloChat = true;

  var TEXT = {
    launcher: 'Chat with Merqelo',
    unread: 'New reply from Merqelo',
    title: 'Chat with Merqelo',
    statusOnline: 'Online now',
    statusOffline: 'Away',
    close: 'Close chat',
    introOnline: 'Ask us about a product or your order, and someone on our team will reply here.',
    introOffline: "No one is online right now. Leave a message with your email address and we'll reply by email.",
    placeholder: 'Write a message',
    email: 'Email',
    emailHintOnline: 'Optional. It lets us reach you if you leave the page.',
    name: 'Name (optional)',
    send: 'Send',
    sentOnline: "Message sent. We'll reply in this chat.",
    sentOffline: "Thanks, we have your message. We'll reply to {email}.",
    staffTyping: '{name} is typing',
    errorSend: "Your message didn't send. Check your connection and try again.",
    errorEmailRequired: 'Add your email so we can reply.',
    errorEmailInvalid: "That email address doesn't look right.",
    errorTooMany: "Your message didn't send. You're sending too fast, so wait a minute and try again.",
    closed: 'This conversation is closed. Send a message to start a new one.',
    privacy: "While you chat, our team can see the page you're on, your cart and when you're typing, but not your message until you send it.",
    staff: 'Merqelo',
    you: 'You',
    hide: 'Hide message'
  };

  var API = String(CONFIG.api).replace(/\/+$/, '');
  var KEY = 'mqChat';
  var ABLY_SRC = 'https://cdn.ably.com/lib/ably.min-2.js';
  var PING_EVERY = 30000;

  // ---- small helpers ----------------------------------------------------------------------------
  function store(kind) {
    try {
      return window[kind];
    } catch (e) {
      return null;
    }
  }
  function read(kind, key) {
    try {
      var s = store(kind);
      return s ? JSON.parse(s.getItem(key) || 'null') : null;
    } catch (e) {
      return null;
    }
  }
  function write(kind, key, value) {
    try {
      var s = store(kind);
      if (!s) return;
      if (value == null) s.removeItem(key);
      else s.setItem(key, JSON.stringify(value));
    } catch (e) {}
  }
  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    for (var k in attrs || {}) {
      if (k === 'text') n.textContent = attrs[k];
      else if (k === 'class') n.className = attrs[k];
      else n.setAttribute(k, attrs[k]);
    }
    (children || []).forEach(function (c) {
      if (c) n.appendChild(c);
    });
    return n;
  }
  function post(path, body) {
    return fetch(API + '/' + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      keepalive: path === 'ping',
      credentials: 'omit'
    });
  }

  // ---- state ------------------------------------------------------------------------------------
  var saved = read('localStorage', KEY) || {};
  var state = {
    token: saved.token || null,
    consent: false,
    enabled: false,
    online: false,
    chat: null,
    open: read('sessionStorage', KEY + ':open') === true,
    messages: [],
    convoOpen: true,
    email: saved.email || null,
    sentNote: '',
    cart: undefined,
    identity: read('sessionStorage', KEY + ':identity'),
    forced: false,
    sending: false
  };
  if (/[?&]mq_chat=on\b/.test(location.search)) write('sessionStorage', KEY + ':forced', true);
  state.forced = read('sessionStorage', KEY + ':forced') === true;

  function visitorId() {
    return state.token ? state.token.split('.')[0] : null;
  }
  function saveToken(token) {
    if (token === state.token) return;
    state.token = token;
    var s = read('localStorage', KEY) || {};
    s.token = token;
    write('localStorage', KEY, token ? s : null);
    if (!token) disconnect();
  }

  // ---- consent: the same check PostHog uses -----------------------------------------------------
  function analyticsAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return !privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || privacy.analyticsProcessingAllowed();
  }

  // ---- what we send -----------------------------------------------------------------------------
  function utm() {
    var out = {};
    try {
      new URLSearchParams(location.search).forEach(function (v, k) {
        if (/^utm_(source|medium|campaign|term|content)$/.test(k)) out[k] = v;
      });
    } catch (e) {}
    return out;
  }
  function pageInfo() {
    return { url: location.href.replace(/([?&])mq_chat=on(&|$)/, '$1').replace(/[?&]$/, ''), title: document.title.slice(0, 200), type: CONFIG.page || undefined };
  }
  function loadCart() {
    return fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (c) {
        if (!c) return null;
        return {
          count: c.item_count || 0,
          total: c.total_price || 0,
          currency: c.currency || 'USD',
          items: (c.items || []).slice(0, 50).map(function (i) {
            return {
              title: String(i.product_title || i.title || '').slice(0, 160),
              variant: i.variant_title ? String(i.variant_title).slice(0, 120) : undefined,
              quantity: i.quantity || 0,
              price: i.final_price || i.price || 0,
              url: i.url ? location.origin + i.url : undefined,
              image: typeof i.image === 'string' && i.image ? (i.image.indexOf('//') === 0 ? 'https:' + i.image : i.image) : undefined
            };
          })
        };
      })
      .catch(function () {
        return null;
      });
  }
  /** Data about the visit goes out only with analytics consent, or while they are in an open chat. */
  function sharing() {
    return state.consent || Boolean(state.chat && state.chat.open);
  }
  function base() {
    var b = { token: state.token || undefined, consent: state.consent };
    if (state.identity) b.identity = state.identity;
    if (CONFIG.account && sharing()) b.account = CONFIG.account;
    return b;
  }

  var firstPing = true;
  function ping(extra) {
    var body = base();
    if (sharing()) {
      body.page = pageInfo();
      body.visible = document.visibilityState === 'visible';
      if (state.cart !== undefined) body.cart = state.cart;
      if (firstPing) {
        if (document.referrer && document.referrer.indexOf(location.origin) !== 0) body.referrer = document.referrer;
        body.utm = utm();
      }
    }
    for (var k in extra || {}) body[k] = extra[k];
    firstPing = false;
    return post('ping', body)
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (res) {
        if (!res) return;
        saveToken(res.token || null);
        state.enabled = Boolean(res.enabled);
        state.online = Boolean(res.online);
        var wasSharing = sharing();
        state.chat = res.chat || null;
        if (sharing() && !wasSharing && !state.consent) {
          // In a chat without analytics consent: from now on the page and cart go along.
          ping();
        }
        render();
        if (state.chat && (state.open || state.chat.unread)) connect();
      })
      .catch(function () {
        render();
      });
  }

  function refreshCart() {
    if (!sharing()) return Promise.resolve();
    return loadCart().then(function (cart) {
      state.cart = cart;
    });
  }

  // ---- identity through the app proxy -----------------------------------------------------------
  function identify() {
    if (!CONFIG.proxy || !CONFIG.account || state.identity) return Promise.resolve();
    return fetch('/apps/support/identify', { credentials: 'same-origin' })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (res) {
        if (res && res.identity) {
          state.identity = res.identity;
          write('sessionStorage', KEY + ':identity', res.identity);
        }
      })
      .catch(function () {});
  }

  // ---- conversation -----------------------------------------------------------------------------
  function loadConversation() {
    if (!state.token) return Promise.resolve();
    return fetch(API + '/chat?token=' + encodeURIComponent(state.token), { credentials: 'omit' })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (res) {
        if (!res) return;
        state.messages = res.messages || [];
        state.convoOpen = res.open !== false;
        if (res.email) state.email = res.email;
        if (state.chat) state.chat.unread = 0;
        render();
      })
      .catch(function () {});
  }

  function send(text, email, name) {
    state.sending = true;
    render();
    var body = base();
    body.text = text;
    body.page = pageInfo();
    if (state.cart !== undefined && state.cart !== null) body.cart = state.cart;
    if (email) body.email = email;
    if (name) body.name = name;
    return post('chat', body)
      .then(function (r) {
        return r.json().then(function (res) {
          return { ok: r.ok, status: r.status, res: res };
        });
      })
      .then(function (out) {
        state.sending = false;
        if (!out.ok) {
          var code = out.res && out.res.error;
          showError(
            code === 'email_required' ? TEXT.errorEmailRequired : code === 'email_invalid' ? TEXT.errorEmailInvalid : code === 'too_many' ? TEXT.errorTooMany : TEXT.errorSend
          );
          render();
          return false;
        }
        var res = out.res;
        saveToken(res.token);
        state.online = Boolean(res.online);
        state.messages = res.messages || [];
        state.convoOpen = res.open !== false;
        state.chat = { unread: 0, open: true };
        if (res.email) {
          state.email = res.email;
          var s = read('localStorage', KEY) || {};
          s.email = res.email;
          write('localStorage', KEY, s);
        }
        state.sentNote = res.online ? TEXT.sentOnline : TEXT.sentOffline.replace('{email}', res.email || email || '');
        render();
        connect();
        return true;
      })
      .catch(function () {
        state.sending = false;
        showError(TEXT.errorSend);
        render();
        return false;
      });
  }

  // ---- live replies and typing (Ably, loaded only once a chat is active) ------------------------
  var rt = null;
  var rtLoading = false;
  var pollTimer = null;
  var staffTyping = { name: '', until: 0 };
  function loadAbly() {
    if (window.Ably) return Promise.resolve(window.Ably);
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = ABLY_SRC;
      s.async = true;
      s.onload = function () {
        resolve(window.Ably);
      };
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }
  var rtOff = false;
  /** Without live updates (or if they fail), check for replies every 10 seconds while open. */
  function startPolling() {
    if (pollTimer) return;
    pollTimer = setInterval(function () {
      if (state.open && state.chat) loadConversation();
    }, 10000);
  }
  function tokenRequest() {
    return fetch(API + '/realtime?token=' + encodeURIComponent(state.token || ''), { credentials: 'omit' }).then(function (r) {
      return r.ok ? r.json() : Promise.reject(new Error('live updates are off'));
    });
  }
  function connect() {
    var id = visitorId();
    if (!id || rt || rtLoading || rtOff) return;
    rtLoading = true;
    tokenRequest()
      .then(function (first) {
        return loadAbly().then(function (Ably) {
          var initial = first;
          rt = new Ably.Realtime({
            authCallback: function (_params, cb) {
              if (initial) {
                var tr = initial;
                initial = null;
                cb(null, tr);
                return;
              }
              tokenRequest()
                .then(function (tr) {
                  cb(null, tr);
                })
                .catch(function (e) {
                  cb(e, null);
                });
            },
            closeOnUnload: true
          });
          rt.connection.on('failed', startPolling);
          rt.channels.get('site:visitor:' + id).subscribe(function (msg) {
            if (msg.name === 'message') {
              if (state.open) loadConversation();
              else ping();
            }
          });
          rt.channels.get('site:typing:' + id).subscribe('typing', function (msg) {
            var d = msg.data || {};
            if (d.from !== 'staff') return;
            staffTyping = { name: d.name || TEXT.staff, until: Date.now() + 5000 };
            render();
            setTimeout(render, 5100);
          });
          rtLoading = false;
        });
      })
      .catch(function () {
        rtLoading = false;
        rtOff = true;
        startPolling();
      });
  }
  function disconnect() {
    if (rt) {
      try {
        rt.close();
      } catch (e) {}
    }
    rt = null;
  }
  var lastTyping = 0;
  function signalTyping() {
    var id = visitorId();
    if (!rt || !id) return;
    var now = Date.now();
    if (now - lastTyping < 2500) return;
    lastTyping = now;
    try {
      rt.channels.get('site:typing:' + id).publish('typing', { from: 'visitor' });
    } catch (e) {}
  }

  // ---- interface --------------------------------------------------------------------------------
  var ui = null;
  var errorText = '';
  function showError(t) {
    errorText = t;
  }

  var CSS =
    '.mqc{--o:var(--mq-orange,#ff661d);--od:var(--mq-orange-deep,#e4520c);--ink:var(--mq-ink,#1c1c1c);--mut:var(--mq-muted,#66615c);--line:rgb(28 28 28 / .1);--pan:#f7f5f1;--ease:cubic-bezier(.16,1,.3,1);font-family:var(--mq-font-text,system-ui,-apple-system,sans-serif);color:var(--ink);-webkit-font-smoothing:antialiased}' +
    '.mqc *{box-sizing:border-box}' +
    '.mqc button{font:inherit}' +
    // Launcher: the chat bubble turns into a close button while the panel is open.
    '.mqc-btn{position:fixed;right:20px;bottom:20px;z-index:2147482000;width:60px;height:60px;border-radius:50%;border:0;background:var(--o);color:#fff;display:grid;place-items:center;cursor:pointer;box-shadow:0 10px 28px -6px rgb(255 102 29 / .55),0 2px 6px rgb(0 0 0 / .12);transition:transform .25s var(--ease),background-color .2s,box-shadow .25s;animation:mqc-launch .5s var(--ease) both}' +
    '.mqc-btn:hover{background:var(--od);transform:translateY(-2px) scale(1.04);box-shadow:0 14px 32px -6px rgb(255 102 29 / .6),0 2px 6px rgb(0 0 0 / .14)}' +
    '.mqc-btn:active{transform:scale(.96)}.mqc-btn:focus-visible{outline:3px solid var(--ink);outline-offset:3px}' +
    '.mqc-btn svg{grid-area:1/1;transition:transform .3s var(--ease),opacity .2s}' +
    '.mqc-ico-x{opacity:0;transform:rotate(-90deg) scale(.6)}' +
    '.mqc-open .mqc-ico-chat{opacity:0;transform:rotate(90deg) scale(.6)}.mqc-open .mqc-ico-x{opacity:1;transform:none}' +
    '.mqc-count{position:absolute;top:-3px;right:-3px;min-width:22px;height:22px;padding:0 6px;border-radius:11px;background:var(--ink);color:#fff;font-size:12px;font-weight:700;line-height:18px;text-align:center;border:2px solid #fff;animation:mqc-pop .35s var(--ease) both}' +
    // Panel.
    '.mqc-panel{position:fixed;right:20px;bottom:96px;z-index:2147482001;width:384px;max-width:calc(100vw - 32px);height:min(640px,calc(100vh - 128px));background:#fff;border-radius:22px;box-shadow:0 24px 64px -16px rgb(28 28 28 / .38),0 0 0 1px var(--line);display:flex;flex-direction:column;overflow:hidden;transform-origin:calc(100% - 30px) calc(100% + 46px);animation:mqc-in .38s var(--ease) both}' +
    '.mqc-panel.mqc-out{animation:mqc-out .2s cubic-bezier(.4,0,1,1) both;pointer-events:none}' +
    '@keyframes mqc-in{from{opacity:0;transform:translateY(16px) scale(.92)}to{opacity:1;transform:none}}' +
    '@keyframes mqc-out{from{opacity:1;transform:none}to{opacity:0;transform:translateY(12px) scale(.94)}}' +
    '@keyframes mqc-launch{from{opacity:0;transform:scale(.4)}to{opacity:1;transform:none}}' +
    '@keyframes mqc-pop{from{opacity:0;transform:scale(.5)}to{opacity:1;transform:none}}' +
    '@keyframes mqc-rise{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}' +
    '@keyframes mqc-dot{0%,60%,100%{transform:translateY(0);opacity:.45}30%{transform:translateY(-4px);opacity:1}}' +
    '@keyframes mqc-sheet{from{transform:translateY(100%)}to{transform:none}}' +
    '@keyframes mqc-sheet-out{from{transform:none}to{transform:translateY(100%)}}' +
    '@keyframes mqc-spin{to{transform:rotate(360deg)}}' +
    '@media (max-width:600px){.mqc-panel{inset:0;width:auto;max-width:none;height:auto;border-radius:0;box-shadow:none;animation:mqc-sheet .42s var(--ease) both}.mqc-panel.mqc-out{animation:mqc-sheet-out .25s cubic-bezier(.4,0,1,1) both}.mqc-open .mqc-btn{opacity:0;pointer-events:none;transform:scale(.6)}}' +
    // Header.
    '.mqc-head{position:relative;display:flex;align-items:center;gap:12px;padding:18px 16px 18px 20px;background:var(--ink);color:#fff;box-shadow:inset 0 -3px 0 var(--o)}' +
    '.mqc-head-text{position:relative;flex:1;min-width:0}' +
    '.mqc-title{margin:0;font-family:var(--mq-font-display,inherit);font-size:17px;font-weight:800;letter-spacing:-.01em;line-height:1.2;color:#fff}' +
    '.mqc-status{display:flex;align-items:center;gap:7px;margin-top:4px;font-size:12.5px;color:rgb(255 255 255 / .72)}' +
    '.mqc-status i{width:8px;height:8px;border-radius:50%;background:#9a948b;flex:none}.mqc-status.mqc-live i{background:#3ccf7e;box-shadow:0 0 0 3px rgb(60 207 126 / .25)}' +
    '.mqc-x{position:relative;flex:none;border:0;background:rgb(255 255 255 / .1);color:#fff;cursor:pointer;width:34px;height:34px;border-radius:50%;display:grid;place-items:center;transition:background-color .2s}.mqc-x:hover{background:rgb(255 255 255 / .2)}.mqc-x:focus-visible{outline:2px solid #fff;outline-offset:2px}' +
    // Conversation.
    '.mqc-body{flex:1;overflow-y:auto;overscroll-behavior:contain;padding:18px 16px 10px;display:flex;flex-direction:column;background:var(--pan);scroll-behavior:smooth}' +
    '.mqc-welcome{align-self:flex-start;max-width:88%;padding:12px 15px;background:#fff;border-radius:18px 18px 18px 6px;box-shadow:0 1px 2px rgb(28 28 28 / .06),0 0 0 1px var(--line);font-size:14.5px;line-height:1.5}' +
    '.mqc-privacy{display:flex;gap:6px;margin:10px 4px 6px;font-size:11.5px;line-height:1.45;color:var(--mut)}.mqc-privacy svg{flex:none;margin-top:2px;opacity:.7}' +
    '.mqc-row{display:flex;align-items:flex-end;gap:8px;margin-top:3px}.mqc-row.mqc-first{margin-top:14px}' +
    '.mqc-row.mqc-mine{flex-direction:row-reverse}' +
    '.mqc-av{flex:none;width:28px;height:28px;border-radius:50%;background:var(--ink);color:#fff;display:grid;place-items:center;font-size:12px;font-weight:700;visibility:hidden}.mqc-row.mqc-last .mqc-av{visibility:visible}.mqc-mine .mqc-av{display:none}' +
    '.mqc-stack{display:flex;flex-direction:column;align-items:flex-start;max-width:80%;min-width:0}.mqc-mine .mqc-stack{align-items:flex-end}' +
    '.mqc-who{font-size:11.5px;font-weight:700;color:var(--mut);margin:0 0 4px 4px}' +
    '.mqc-msg{padding:10px 14px;border-radius:18px;font-size:14.5px;line-height:1.45;white-space:pre-wrap;overflow-wrap:anywhere}' +
    '.mqc-them .mqc-msg{background:#fff;box-shadow:0 1px 2px rgb(28 28 28 / .06),0 0 0 1px var(--line)}.mqc-them.mqc-last .mqc-msg{border-bottom-left-radius:6px}' +
    '.mqc-mine .mqc-msg{background:var(--ink);color:#fff}.mqc-mine.mqc-last .mqc-msg{border-bottom-right-radius:6px}' +
    '.mqc-time{font-size:11px;color:var(--mut);margin:4px 4px 0;opacity:.8}' +
    '.mqc-new{animation:mqc-rise .35s var(--ease) both}' +
    '.mqc-note{align-self:center;max-width:90%;margin:14px 0 4px;padding:6px 12px;border-radius:999px;background:rgb(28 28 28 / .05);font-size:12px;line-height:1.4;color:var(--mut);text-align:center}' +
    '.mqc-typing{display:flex;align-items:flex-end;gap:8px;margin-top:14px;animation:mqc-rise .3s var(--ease) both}' +
    '.mqc-dots{display:inline-flex;gap:4px;padding:13px 14px;background:#fff;border-radius:18px 18px 18px 6px;box-shadow:0 1px 2px rgb(28 28 28 / .06),0 0 0 1px var(--line)}' +
    '.mqc-dots span{width:7px;height:7px;border-radius:50%;background:var(--mut);animation:mqc-dot 1.2s infinite}.mqc-dots span:nth-child(2){animation-delay:.15s}.mqc-dots span:nth-child(3){animation-delay:.3s}' +
    '.mqc-sr{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}' +
    // Message box.
    '.mqc-form{padding:10px 12px 12px;background:#fff;border-top:1px solid var(--line);display:flex;flex-direction:column;gap:8px}' +
    '.mqc-fields{display:grid;grid-template-columns:1fr 1fr;gap:8px}.mqc-fields[hidden],.mqc-err[hidden]{display:none}.mqc-fields.mqc-one{grid-template-columns:1fr}' +
    '.mqc-label{display:flex;flex-direction:column;gap:4px;font-size:12px;font-weight:600;color:var(--ink);min-width:0}' +
    '.mqc-hint{font-size:11px;font-weight:400;color:var(--mut);grid-column:1/-1;margin-top:-2px}' +
    '.mqc-input{font:inherit;font-size:16px;width:100%;height:40px;border:1px solid rgb(28 28 28 / .16);border-radius:12px;padding:0 12px;background:#fff;color:var(--ink);transition:border-color .2s,box-shadow .2s}' +
    '.mqc-input:focus{outline:none;border-color:var(--o);box-shadow:0 0 0 3px rgb(255 102 29 / .18)}' +
    '.mqc-compose{display:flex;align-items:flex-end;gap:6px;padding:5px 5px 5px 14px;border:1px solid rgb(28 28 28 / .16);border-radius:24px;background:#fff;transition:border-color .2s,box-shadow .2s}' +
    '.mqc-compose:focus-within{border-color:var(--o);box-shadow:0 0 0 3px rgb(255 102 29 / .18)}' +
    '.mqc-text{flex:1;min-width:0;font:inherit;font-size:16px;line-height:22px;height:38px;max-height:132px;padding:8px 0;border:0;background:transparent;color:var(--ink);resize:none;outline:none}' +
    '.mqc-text::placeholder{color:#9a948b}' +
    '.mqc-send{flex:none;width:38px;height:38px;border-radius:50%;border:0;background:var(--o);color:#fff;display:grid;place-items:center;cursor:pointer;transition:background-color .2s,transform .2s var(--ease),opacity .2s}' +
    '.mqc-send:hover:not(:disabled){background:var(--od);transform:scale(1.06)}.mqc-send:active:not(:disabled){transform:scale(.92)}' +
    '.mqc-send:disabled{background:#e8e3db;color:#9a948b;cursor:default}.mqc-send:focus-visible{outline:2px solid var(--ink);outline-offset:2px}' +
    '.mqc-send.mqc-busy svg{display:none}.mqc-send.mqc-busy:after{content:"";width:16px;height:16px;border-radius:50%;border:2px solid rgb(255 255 255 / .4);border-top-color:#fff;animation:mqc-spin .7s linear infinite}' +
    '.mqc-err{margin:0;font-size:12.5px;color:var(--mq-rust,#a93c12)}' +
    // A new reply while the panel is closed.
    '.mqc-teaser{position:fixed;right:20px;bottom:96px;z-index:2147482001;width:300px;max-width:calc(100vw - 40px);background:#fff;border-radius:18px 18px 6px 18px;box-shadow:0 18px 44px -12px rgb(28 28 28 / .32),0 0 0 1px var(--line);padding:13px 40px 13px 15px;color:var(--ink);animation:mqc-rise .4s var(--ease) both}' +
    '.mqc-teaser[hidden]{display:none}' +
    '.mqc-teaser-open{all:unset;display:block;cursor:pointer}.mqc-teaser-open:focus-visible{outline:2px solid var(--ink);outline-offset:4px;border-radius:6px}' +
    '.mqc-teaser .mqc-who{margin:0 0 3px}' +
    '.mqc-teaser-text{display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;font-size:14px;line-height:1.45;white-space:pre-wrap}' +
    '.mqc-teaser-x{position:absolute;top:8px;right:8px;border:0;background:transparent;color:var(--mut);cursor:pointer;width:26px;height:26px;border-radius:50%;display:grid;place-items:center}.mqc-teaser-x:hover{background:rgb(28 28 28 / .06)}' +
    '.mqc-teaser-x:focus-visible{outline:2px solid var(--ink)}' +
    '@media (max-width:600px){.mqc-btn{right:16px;bottom:16px}.mqc-teaser{right:16px;bottom:88px}}' +
    '@media (prefers-reduced-motion:reduce){.mqc *,.mqc *:before,.mqc *:after{animation-duration:1ms!important;animation-iteration-count:1!important;transition-duration:1ms!important}.mqc-body{scroll-behavior:auto}}';

  function svg(path, size, stroke) {
    return (
      '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="' + (stroke || 2) +
      '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + path + '</svg>'
    );
  }
  var ICON_CHAT = svg('<path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12z"/>', 26);
  var ICON_X = svg('<path d="M18 6 6 18M6 6l12 12"/>', 22, 2.2);
  var ICON_X_SMALL = svg('<path d="M18 6 6 18M6 6l12 12"/>', 16, 2.2);
  var ICON_DOWN = svg('<path d="m6 9 6 6 6-6"/>', 20, 2.2);
  var ICON_SEND = svg('<path d="M12 19V5M5 12l7-7 7 7"/>', 18, 2.4);
  var ICON_LOCK = svg('<rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/>', 12);

  function build() {
    if (ui) return;
    var style = el('style', { text: CSS });
    document.head.appendChild(style);
    var root = el('div', { class: 'mqc' });
    var btn = el('button', { class: 'mqc-btn', type: 'button', 'aria-expanded': 'false', 'aria-controls': 'mqc-panel' });
    btn.innerHTML = ICON_CHAT.replace('<svg', '<svg class="mqc-ico-chat"') + ICON_X.replace('<svg', '<svg class="mqc-ico-x"');
    var count = el('span', { class: 'mqc-count', 'aria-hidden': 'true', hidden: '' });
    btn.appendChild(count);
    btn.addEventListener('click', function () {
      setOpen(!state.open);
    });
    var teaser = el('div', { class: 'mqc-teaser', role: 'status', hidden: '' });
    var teaserOpen = el('button', { type: 'button', class: 'mqc-teaser-open' });
    var teaserWho = el('span', { class: 'mqc-who' });
    var teaserText = el('span', { class: 'mqc-teaser-text' });
    teaserOpen.appendChild(teaserWho);
    teaserOpen.appendChild(teaserText);
    teaserOpen.addEventListener('click', function () {
      setOpen(true);
    });
    var teaserX = el('button', { class: 'mqc-teaser-x', type: 'button', 'aria-label': TEXT.hide });
    teaserX.innerHTML = ICON_X_SMALL;
    teaserX.addEventListener('click', function (e) {
      e.stopPropagation();
      if (state.chat && state.chat.last) write('sessionStorage', KEY + ':hidden', state.chat.last.id);
      render();
    });
    teaser.appendChild(teaserOpen);
    teaser.appendChild(teaserX);
    root.appendChild(teaser);
    root.appendChild(btn);
    document.body.appendChild(root);
    ui = { root: root, btn: btn, count: count, panel: null, teaser: teaser, teaserWho: teaserWho, teaserText: teaserText };
  }

  function setOpen(open) {
    state.open = open;
    write('sessionStorage', KEY + ':open', open || null);
    errorText = '';
    if (open) {
      if (state.chat) {
        loadConversation();
        connect();
      }
      refreshCart();
    }
    render();
    if (open && ui && ui.panel) {
      var t = ui.panel.querySelector('textarea');
      if (t) t.focus({ preventScroll: true });
    } else if (!open && ui) {
      ui.btn.focus();
    }
  }

  /** The panel plays its closing animation, then leaves the page. */
  function closePanel() {
    var p = ui.panel;
    ui.panel = null;
    if (!p) return;
    p.classList.add('mqc-out');
    setTimeout(function () {
      p.remove();
    }, 260);
  }

  function timeOf(at) {
    try {
      return new Date(at).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
    } catch (e) {
      return '';
    }
  }

  /** Messages from the same person a few minutes apart share one name and one time. */
  function sameRun(a, b) {
    return Boolean(a && b && a.from === b.from && (a.name || '') === (b.name || '') && Math.abs(new Date(a.at) - new Date(b.at)) < 300000);
  }

  var seen = {};
  function bubble(m, first, last) {
    var mine = m.from === 'visitor';
    var name = mine ? TEXT.you : m.name || TEXT.staff;
    var cls = 'mqc-row ' + (mine ? 'mqc-mine' : 'mqc-them') + (first ? ' mqc-first' : '') + (last ? ' mqc-last' : '') + (seen[m.id] ? '' : ' mqc-new');
    seen[m.id] = true;
    var stack = el('div', { class: 'mqc-stack' }, [
      first && !mine ? el('span', { class: 'mqc-who', text: name }) : null,
      el('div', { class: 'mqc-msg' }, [mine ? el('span', { class: 'mqc-sr', text: TEXT.you + ': ' }) : null, document.createTextNode(m.text)]),
      last && m.at ? el('span', { class: 'mqc-time', text: timeOf(m.at) }) : null
    ]);
    return el('div', { class: cls }, [el('span', { class: 'mqc-av', 'aria-hidden': 'true', text: name.charAt(0).toUpperCase() }), stack]);
  }

  /** The panel's frame is built once per opening; the conversation and the form are updated in
   * place, so a check-in never disturbs what the visitor is typing. */
  function buildPanel() {
    var p = el('div', { class: 'mqc-panel', id: 'mqc-panel', role: 'dialog', 'aria-label': TEXT.title });
    var x = el('button', { class: 'mqc-x', type: 'button', 'aria-label': TEXT.close });
    x.innerHTML = ICON_DOWN;
    x.addEventListener('click', function () {
      setOpen(false);
    });
    var status = el('div', { class: 'mqc-status' }, [el('i'), el('span')]);
    p.appendChild(el('div', { class: 'mqc-head' }, [el('div', { class: 'mqc-head-text' }, [el('h2', { class: 'mqc-title', text: TEXT.title }), status]), x]));
    var body = el('div', { class: 'mqc-body', 'aria-live': 'polite' });
    p.appendChild(body);
    var form = el('form', { class: 'mqc-form', novalidate: '' });
    var fields = el('div', { class: 'mqc-fields' });
    var text = el('textarea', { class: 'mqc-text', name: 'text', rows: '1', maxlength: '2000', placeholder: TEXT.placeholder, 'aria-label': TEXT.placeholder });
    text.value = state.draft || '';
    var sendBtn = el('button', { class: 'mqc-send', type: 'submit', 'aria-label': TEXT.send, title: TEXT.send });
    sendBtn.innerHTML = ICON_SEND;
    function fit() {
      text.style.height = 'auto';
      text.style.height = Math.min(text.scrollHeight, 132) + 'px';
      sendBtn.disabled = state.sending || !text.value.trim();
    }
    text.addEventListener('input', function () {
      state.draft = text.value;
      fit();
      signalTyping();
    });
    text.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) {
        e.preventDefault();
        if (form.requestSubmit) form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true }));
      }
    });
    var err = el('p', { class: 'mqc-err', role: 'alert' });
    form.appendChild(fields);
    form.appendChild(err);
    form.appendChild(el('div', { class: 'mqc-compose' }, [text, sendBtn]));
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (state.sending) return;
      var value = text.value.trim();
      if (!value) return;
      var emailInput = fields.querySelector('input[name="email"]');
      var nameInput = fields.querySelector('input[name="name"]');
      var email = emailInput ? emailInput.value.trim() : '';
      if (emailInput && !state.online && !email) {
        showError(TEXT.errorEmailRequired);
        render();
        emailInput.focus();
        return;
      }
      if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        showError(TEXT.errorEmailInvalid);
        render();
        emailInput.focus();
        return;
      }
      errorText = '';
      send(value, email, nameInput ? nameInput.value.trim() : '').then(function (ok) {
        if (ok) {
          state.draft = '';
          text.value = '';
        }
        render();
        fit();
        text.focus({ preventScroll: true });
      });
    });
    p.appendChild(form);
    p.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });
    ui.root.appendChild(p);
    ui.panel = p;
    ui.status = status;
    ui.body = body;
    ui.fields = fields;
    ui.err = err;
    ui.sendBtn = sendBtn;
    ui.fit = fit;
    ui.fieldsKey = null;
    state.renderedOnce = false;
    // Messages already in the conversation appear without animating in.
    state.messages.forEach(function (m) {
      seen[m.id] = true;
    });
    requestAnimationFrame(fit);
  }

  function renderBody() {
    var body = ui.body;
    var atBottom = body.scrollHeight - body.scrollTop - body.clientHeight < 60;
    body.textContent = '';
    var msgs = state.messages;
    var hasConvo = msgs.length > 0;
    if (!hasConvo || !state.convoOpen) {
      body.appendChild(el('div', { class: 'mqc-welcome', text: state.online ? TEXT.introOnline : TEXT.introOffline }));
    }
    var privacy = el('p', { class: 'mqc-privacy' });
    privacy.innerHTML = ICON_LOCK;
    privacy.appendChild(el('span', { text: TEXT.privacy }));
    body.appendChild(privacy);
    msgs.forEach(function (m, i) {
      body.appendChild(bubble(m, !sameRun(msgs[i - 1], m), !sameRun(m, msgs[i + 1])));
    });
    if (hasConvo && !state.convoOpen) body.appendChild(el('p', { class: 'mqc-note', text: TEXT.closed }));
    else if (state.sentNote && hasConvo && msgs[msgs.length - 1].from === 'visitor') body.appendChild(el('p', { class: 'mqc-note', text: state.sentNote }));
    if (staffTyping.until > Date.now()) {
      body.appendChild(
        el('div', { class: 'mqc-typing' }, [
          el('span', { class: 'mqc-av', 'aria-hidden': 'true', style: 'visibility:visible', text: (staffTyping.name || TEXT.staff).charAt(0).toUpperCase() }),
          el('span', { class: 'mqc-dots' }, [el('span'), el('span'), el('span'), el('span', { class: 'mqc-sr', text: TEXT.staffTyping.replace('{name}', staffTyping.name) })])
        ])
      );
    }
    if (atBottom || !state.renderedOnce) {
      // Jump on first paint, glide afterwards.
      if (!state.renderedOnce) body.style.scrollBehavior = 'auto';
      body.scrollTop = body.scrollHeight;
      if (!state.renderedOnce) body.style.scrollBehavior = '';
    }
    state.renderedOnce = true;
  }

  /** Name and email fields: the name on the first message, the email while nobody is online and we
   * have none (optional, with a hint, while someone is). Rebuilt only when that changes. */
  function renderFields() {
    var hasConvo = state.messages.length > 0;
    var askEmail = !state.email && (!state.online || !hasConvo || !state.convoOpen);
    var askName = !hasConvo;
    var key = [askName, askEmail, state.online].join('|');
    if (key === ui.fieldsKey) return;
    ui.fieldsKey = key;
    var keep = {};
    Array.prototype.forEach.call(ui.fields.querySelectorAll('input'), function (i) {
      keep[i.name] = i.value;
    });
    ui.fields.textContent = '';
    ui.fields.classList.toggle('mqc-one', !(askName && askEmail));
    if (askName) {
      var nameInput = el('input', { class: 'mqc-input', type: 'text', name: 'name', autocomplete: 'name', maxlength: '120' });
      nameInput.value = keep.name != null ? keep.name : (CONFIG.account && CONFIG.account.name) || '';
      ui.fields.appendChild(el('label', { class: 'mqc-label' }, [document.createTextNode(TEXT.name), nameInput]));
    }
    if (askEmail) {
      var emailInput = el('input', { class: 'mqc-input', type: 'email', name: 'email', autocomplete: 'email', maxlength: '200' });
      emailInput.value = keep.email != null ? keep.email : (CONFIG.account && CONFIG.account.email) || '';
      if (!state.online) emailInput.required = true;
      ui.fields.appendChild(el('label', { class: 'mqc-label' }, [document.createTextNode(TEXT.email), emailInput]));
      if (state.online) ui.fields.appendChild(el('span', { class: 'mqc-hint', text: TEXT.emailHintOnline }));
    }
    ui.fields.hidden = !askName && !askEmail;
  }

  function render() {
    var show = state.enabled || state.forced || Boolean(state.chat);
    if (!show) {
      if (ui) ui.root.hidden = true;
      return;
    }
    build();
    ui.root.hidden = false;
    var unreadCount = state.chat && !state.open ? state.chat.unread || 0 : 0;
    ui.count.hidden = !unreadCount;
    ui.count.textContent = unreadCount > 9 ? '9+' : String(unreadCount);
    ui.btn.setAttribute('aria-label', state.open ? TEXT.close : unreadCount ? TEXT.unread : TEXT.launcher);
    ui.btn.setAttribute('aria-expanded', state.open ? 'true' : 'false');
    ui.root.classList.toggle('mqc-open', state.open);
    var last = state.chat && state.chat.last;
    var showTeaser = Boolean(unreadCount && last && last.id !== read('sessionStorage', KEY + ':hidden'));
    ui.teaser.hidden = !showTeaser;
    if (showTeaser) {
      ui.teaserWho.textContent = last.name || TEXT.staff;
      ui.teaserText.textContent = last.text;
    }
    if (!state.open) {
      if (ui.panel) closePanel();
      return;
    }
    if (!ui.panel) buildPanel();
    ui.status.classList.toggle('mqc-live', state.online);
    ui.status.lastChild.textContent = state.online ? TEXT.statusOnline : TEXT.statusOffline;
    renderBody();
    renderFields();
    ui.err.textContent = errorText;
    ui.err.hidden = !errorText;
    ui.sendBtn.classList.toggle('mqc-busy', state.sending);
    ui.fit();
  }

  // ---- start ------------------------------------------------------------------------------------
  function start() {
    state.consent = analyticsAllowed();
    if (state.forced) render();
    identify()
      .then(refreshCart)
      .then(function () {
        return ping();
      })
      .then(function () {
        if (state.open && state.chat) loadConversation();
      });
    setInterval(function () {
      if (document.visibilityState === 'visible' && sharing()) ping();
    }, PING_EVERY);
    document.addEventListener('visibilitychange', function () {
      if (sharing()) ping();
    });
    document.addEventListener('shopify:cart:lines-update', function () {
      setTimeout(function () {
        refreshCart().then(function () {
          if (sharing()) ping();
        });
      }, 300);
    });
    document.addEventListener('visitorConsentCollected', function (event) {
      var allowed = Boolean(event.detail && event.detail.analyticsAllowed);
      if (allowed === state.consent) return;
      state.consent = allowed;
      refreshCart().then(function () {
        return ping();
      });
    });
  }

  function whenIdle(fn) {
    if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 4000 });
    else setTimeout(fn, 1500);
  }

  whenIdle(function () {
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      // If the consent API cannot load, fall back to Shopify's US default (analytics allowed).
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
        start();
      });
    } else {
      start();
    }
  });
})();
